import React from "react";
import  { useState, useEffect } from 'react';
import './classes/AllAgents.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import AgencySidebar from "./AgencySidebar";
import SalespersonSidebar from "./SalespersonSidebar";

const AllAgents = () => {

    const initialForm = {
        field_agent_sports_value: [],
        field_agent_certifications_value: [],
    };

    const [formData, setFormData] = useState(initialForm);
    const [appliedFormData, setAppliedFormData] = useState(initialForm);
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);
    const {slug} = useParams();
    const [activeAgents, setActiveAgents] = useState([]);
    const [sportList, setSportList] = useState('');
    const [agentCertificateList, setAgentCertification] = useState([]);
    // const agentCertificateList = [
    //     'CFL Certified',
    //     'DEL Certified',
    //     'FIBA Certified',
    //     'FIFA Certified',
    //     'MLB Certified',
    //     'NBA Certified',
    //     'NFLPA Certified',
    //     'NHL Certified',
    //     'NIL Certified',
    //     'PHPA Certified',
    //     'WNBA Certified'
    // ];

    useEffect(() => {
        Promise.all([
            getsportslist(),
            getcertificationslist()
        ])
        .then(() => {
            setIsLoading(false);
        })
        
    },[]);

    async function getsportslist() {
        try {
            const response = await fetch(
                app_url+'smwwagency/agentsports',
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            // if(responsedata.data) {
            //     setSportList(responsedata.data);
            // } 
                if(responsedata.data) {
                const sportslist = responsedata.data.filter(
                    s => s.key !== "nil"
                );
                setSportList(sportslist);
            }
        } catch (err) {
            
        }
    }
    async function getcertificationslist() {
        try {
            const response = await fetch(
                app_url+'smwwagency/getagentcertifications',
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setAgentCertification(responsedata.data.result);
            
            }
        } catch (err) {
            
        }
    }
    const handleChange = (e) => {
        const { name, value, checked } = e.target;

        setFormData((prev) => {
            const currentValues = prev[name] || [];

            if (checked) {
            return {
                ...prev,
                [name]: [...currentValues, value]
            };
            } else {
            return {
                ...prev,
                [name]: currentValues.filter((item) => item !== value)
            };
            }
        });
    };

        //pagination
        const [currentPage, setCurrentPage] = useState(1);
        const [itemsPerPage, setItemsPerPage] = useState(50);

        const [totalItems, setTotalItems] = useState(0);
        const totalPages = Math.ceil(totalItems / itemsPerPage);
    
        // const startIndex =
        //     (currentPage - 1) * itemsPerPage;
        // const endIndex =
        //     startIndex + itemsPerPage;
        // const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
        // const currentItems =
        //     activeAgents.slice(startIndex, endIndex);
    
        // function goToNextPage() {
        //     setCurrentPage(prevPage => prevPage + 1);
        // }
        function goToNextPage() {
            setCurrentPage(prev => Math.min(prev + 1, totalPages));
        }
    
        function goToPrevPage() {
            setCurrentPage(prevPage => prevPage - 1);
        }
    
        function goToSpecificPage(pageNumber) {
            setCurrentPage(pageNumber);
        }
        function renderPaginationControls() {
            // const totalPages = Math.ceil(totalPages / itemsPerPage);

            const goToFirstPage = () => setCurrentPage(1);
            const goToLastPage = () => setCurrentPage(totalPages);

            const maxButtons = 10;
            let startPage = Math.max(1, currentPage - Math.floor(maxButtons / 2));
            // let endPage = startPage + maxButtons - 1;
            let endPage = Math.min(totalPages, startPage + maxButtons - 1);

            if (endPage > totalPages) {
                endPage = totalPages;
                startPage = Math.max(1, endPage - maxButtons + 1);
            }

            const pageNumbers = [];
            for (let i = startPage; i <= endPage; i++) {
                pageNumbers.push(i);
            }

            return (
                <div>
                    {/* {activeAgents.length > itemsPerPage && ( */}
                    {totalItems > itemsPerPage && (
                        <div style={{ textAlign: "center" }} className="all-agent-list-pagination">

                            {/* First + Prev */}
                            {currentPage !== 1 && (
                                <>
                                    <button onClick={goToFirstPage}>« First</button>
                                    <button onClick={goToPrevPage}>‹ Previous</button>
                                </>
                            )}
                            {pageNumbers.map((num) => (
                                <button
                                    key={num}
                                    onClick={() => goToSpecificPage(num)}
                                    style={{
                                        fontWeight: num === currentPage ? "bold" : "normal",
                                        color: num === currentPage ? "#111" : "#2c99d2",
                                    }}
                                >
                                    {num}
                                </button>
                            ))}

                            {/* Next + Last */}
                            {currentPage !== totalPages && (
                                <>
                                    <button onClick={goToNextPage}>Next ›</button>
                                    <button onClick={goToLastPage}>Last »</button>
                                </>
                            )}
                        </div>
                    )}
                </div>
            );
        }

    React.useEffect(() => {
         const fetchData = async () => {
            // Simulate API call to your server
            // In a real application, replace this with your actual fetch logic
            try {
               setIsLoading(true);
            const response = await fetch(app_url+'smwwagency/getallagentlist', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
               page: currentPage,
            pagesize: itemsPerPage,
            // formData:formData,
            formData:appliedFormData,
              }),
            });
            const data = await response.json();
            setActiveAgents(data.data.result);
            setTotalItems(Number(data.data.rowCount));
          }  catch (error) {
                  console.error('Error fetching data:', error);
                } finally {
                  setIsLoading(false); // Set loading to false after fetch completes (success or error)
                }
          };
      
          fetchData();
         
    }, [currentPage,appliedFormData]); // Re-fetch data when these change

    const handleSubmit = async (e) => {
        e.preventDefault();
        // console.log(formData);
        setAppliedFormData({ ...formData });
      try {
        setIsLoading(true);
        const response = await fetch(app_url+'smwwagency/getallagentlist', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
               page: currentPage,
            pagesize: itemsPerPage,
            formData:formData,
              }),
            });
        const data = await response.json();
        setActiveAgents(data.data.result);
        setTotalItems(Number(data.data.rowCount));
        }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
        };

    return (
        <>      
            {isLoading ? (
                <Loading />
            ) : ( 
                <div id="main">
                    <Helmet><title>All Agents</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="all-agent-container">
                            <div>
                                <form onSubmit={handleSubmit}>
                                    <div className="views-exposed-widget">
                                            <label htmlFor="edit-field-agent-certifications-value" style={{textAlign: "center"}}>Filter by Certifications</label>
                                            {agentCertificateList.length > 0 && (
                                                <>
                                                <ul className="all-agent-sports-list">
                                                    {agentCertificateList.map((certificateName) => (
                                                        <li key={certificateName}>
                                                            <label className="sports-checkbox-item">
                                                                <input
                                                                    type="checkbox"
                                                                    name="field_agent_certifications_value"
                                                                    value={certificateName}
                                                                    checked={formData.field_agent_certifications_value?.includes(certificateName)}
                                                                    onChange={handleChange}                                             
                                                                    className="sport-list-input"
                                                                />
                                                                {certificateName}
                                                            </label>
                                                        </li>
                                                    ))}
                                                </ul>
                                                </>
                                            )}
                                    </div>
                                    <div className="views-exposed-widget">
                                        <label htmlFor="edit-field-agent-sports-value" style={{textAlign: "center"}}>Filter by Sports</label>    
                                        {sportList.length > 0 && (
                                            <>
                                            <ul className="all-agent-sports-list">
                                                {sportList.map((sportName) => (
                                                    <li key={sportName}>
                                                    <label className="sports-checkbox-item">
                                                        <input
                                                            type="checkbox"
                                                            name="field_agent_sports_value"
                                                            value={sportName.key}
                                                            onChange={handleChange}
                                                            checked={formData.field_agent_sports_value?.includes(sportName.key)}
                                                            className="sport-list-input"
                                                        />
                                                        {sportName.value}
                                                    </label>
                                                    </li>
                                                ))}
                                            </ul>
                                            </>
                                        )}
                                    </div>
                                    <div className="views-submit-button">
                                        <input type="submit" id="edit-submit-all-agents" name="" value="Apply" className="form-submit" />
                                    </div>
                                </form>
                            </div>
                            {activeAgents.length === 0 ? (<p><b>No Agents found for your criteria, please try another search.</b></p>) : (
                                <div>
                                    <h1>Agents</h1>
                                    <div className="all-agent-list-container">
                                        <ul>
                                            {activeAgents.map((agent, index) => (
                                            <li key={index}>  
                                                <div className="">
                                                    <a href={agent.url}  target="_blank" rel="noreferrer">
                                                        {((agent.image === '') || !agent.image )? (
                                                            <img
                                                                src='/basic/web/images/agency_logo.png'
                                                                alt={agent.name}
                                                                style={{maxWidth: "100px", maxHeight: "100px"}}
                                                            />
                                                        ) : (
                                                            <img
                                                                src={agent.image}
                                                                alt={agent.name}
                                                                style={{maxWidth: "100px", maxHeight: "100px"}}
                                                            />
                                                        )}
                                                    </a>
                                                </div> 

                                                <div className="">
                                                    <a href={agent.url}  target="_blank" rel="noreferrer">{agent.name}</a>
                                                </div>
                                                <div><div dangerouslySetInnerHTML={{ __html: agent.address }} /></div>
                                            </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div style={{clear: "both"}}></div>
                                    {renderPaginationControls()}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="right">
                        <AgencySidebar />
                        <SalespersonSidebar />
                    </div>
                </div>
            )}
        </>
    );
};
export default AllAgents;